import { FC } from "react";
import { Modal } from "react-bootstrap";
import { ThumbnailModalProps } from "../View/_CardGroup";
import _PreviewFile from "./_PreviewFile";

export interface _PreviewModalProps {
    thumbnailModalProps?: ThumbnailModalProps
    setThumbnailModalProps: (modalProps?: ThumbnailModalProps) => void
}

const _PreviewModal: FC<_PreviewModalProps> = ({
    thumbnailModalProps,
    setThumbnailModalProps,
}) => {
    const handleClose = () => {
        setThumbnailModalProps(undefined)
    }

    return <Modal show={thumbnailModalProps !== undefined} onHide={handleClose} key={1} size="xl" className="thumbnail-modal">
        <Modal.Header closeButton>
            <Modal.Title>{thumbnailModalProps && thumbnailModalProps.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {thumbnailModalProps &&
                <_PreviewFile thumbnailModalProps={thumbnailModalProps} setThumbnailModalProps={setThumbnailModalProps} />
            }
        </Modal.Body>
    </Modal>
}

export default _PreviewModal
